import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../../../App/Hooks/reduxHooks'
import { isInstanceOfIThunkError } from '../../../../../utils/interfaceCheck'

import { InfoIcon, ResendContainer, ResendText } from './style'

interface IProps {
  isOnlineBooked: boolean
  appointmentId: number
}

export const ConfirmationEmail: FunctionComponent<IProps> = ({
  isOnlineBooked,
  appointmentId,
}) => {
  const [isReSendSuccess, setIsReSendSuccess] = useState<
    'idle' | 'spinner-third' | 'exclamation-triangle' | 'check'
  >('idle')
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const resendEmail = () => {
    if (isReSendSuccess !== 'idle') {
      return null
    }
    setIsReSendSuccess('spinner-third')
    dispatch(sendConfirmationEmail({ appointmentId })).then(e => {
      const isError = isInstanceOfIThunkError(e)
      if (isError) {
        setIsReSendSuccess('exclamation-triangle')
        return null
      }
      setIsReSendSuccess('check')
      return null
    })
    return null
  }

  if (!isOnlineBooked) {
    return null
  }

  return (
    <ResendContainer onClick={resendEmail}>
      {isReSendSuccess !== 'idle' ? (
        <InfoIcon
          icon={isReSendSuccess}
          showAnimation={isReSendSuccess === 'spinner-third'}
        />
      ) : null}
      <ResendText isClickActive={isReSendSuccess === 'idle'}>
        {t('Resend confirmation mail')}
      </ResendText>
    </ResendContainer>
  )
}
